import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './CTA.css';

const CTA = () => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="cta-content"
        >
          <h2 className="cta-title">Rejoignez notre communauté solidaire</h2>
          <p className="cta-description">
            Inscrivez-vous gratuitement et commencez à bénéficier de tous nos services
          </p>
          <div className="cta-buttons">
            <Link to="/inscription" className="cta-btn primary">
              Créer un compte
            </Link>
            <Link to="/connexion" className="cta-btn secondary">
              Se connecter
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;